import TextPostback from './TextPostback';
export default TextPostback;
